import {} from "@mui/material";
import type React from "react";
import type { CarrierDeliveryProposalCreatePageProps } from "../model";
import { DeliveryProposalCreateInProgress } from "./in-progress";
import { DeliveryProposalCreatePreview } from "./preview";

export const CarrierDeliveryProposalCreatePageUi: React.FC<
  CarrierDeliveryProposalCreatePageProps
> = (props) => {
  if (props.previewValues) {
    return <DeliveryProposalCreatePreview {...props} />;
  }
  return <DeliveryProposalCreateInProgress {...props} />;
};
